import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._closeHandler = () => this.close()
    this.element.addEventListener("close", this._closeHandler)
  }

  disconnect() {
    this.element.removeEventListener("close", this._closeHandler)
  }

  close() {
    const modal = this.element

    // Bootstrap con jQuery
    if (window.jQuery && window.jQuery.fn.modal) {
      window.jQuery(modal).modal("hide")
    } else if (window.bootstrap?.Modal) {
      // Bootstrap 5 sin jQuery
      const instance = window.bootstrap.Modal.getInstance(modal)
      instance?.hide()
    } else {
      // fallback manual
      modal.classList.remove("show")
      modal.style.display = "none"
      document.body.classList.remove("modal-open")

      const backdrop = document.querySelector(".modal-backdrop")
      if (backdrop) backdrop.remove()
    }

    // 🔑 liberar foco
    document.activeElement?.blur()
    document.body.focus()
  }
}
